import type { BillingAddress } from './types';

export type SUPPORTED_COUNTRIES = 'United States' | 'Canada';

// ISO 3166-1 alpha-2 codes
export const isoCountry: Record<SUPPORTED_COUNTRIES, string> = {
  'United States': 'US',
  Canada: 'CA',
};

export function parsePlaceAddress(address: string): BillingAddress {
  const parts = address.split(',');

  const country = (parts.pop()?.trim() ??
    'United States') as SUPPORTED_COUNTRIES;
  const statePostal = parts.pop()?.trim();
  const city = parts.pop()?.trim() ?? '';
  let street2;

  if (parts.length > 1) {
    street2 = parts.pop()?.trim();
  }

  const street = parts.pop()?.trim();

  // Post processing
  const [state, zip] = statePostal?.split(' ') ?? [];

  return {
    street,
    street2,
    city,
    state,
    zip,
    country: isoCountry[country],
  };
}
